'use client';

import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { isDefined } from '@morpho-org/morpho-ts';
import { useEffect, useState } from 'react';
import OperationModeButton from '@/components/SimpleActionPanel/OperationModeButton/OperationModeButton';
import { InterfaceOperation } from '@/operations/operations.types';
import type { VaultV2ActionPanelData } from './vaultV2ActionPanel.mapper';
import { useVaultV2Position } from '../hooks/useVaultV2Position';
import { VaultV2OperationDeposit, VaultV2OperationWithdraw } from './VaultV2OperationPanel';
interface VaultV2SimpleActionPanelProps {
  vaultData: VaultV2ActionPanelData;
  vaultAddress: Address;
  chainId: ChainId;
}
const VaultV2SimpleActionPanel = ({
  vaultData,
  vaultAddress,
  chainId
}: VaultV2SimpleActionPanelProps) => {
  const [type, setType] = useState(InterfaceOperation.InterfaceOperationType.vaultV2Deposit);
  const {
    userVaultShares
  } = useVaultV2Position({
    vaultAddress,
    chainId
  });
  const hasHolding = isDefined(userVaultShares) && userVaultShares > 0n;
  useEffect(() => {
    if (!hasHolding) {
      setType(InterfaceOperation.InterfaceOperationType.vaultV2Deposit);
    }
  }, [hasHolding]);
  return <div className="gap-sm flex basis-[100%] flex-col" data-testid="vault-action-panel">
      <div className="gap-2xs flex items-center justify-stretch">
        <OperationModeButton onClick={() => setType(InterfaceOperation.InterfaceOperationType.vaultV2Deposit)} label="Deposit" isActive={type === InterfaceOperation.InterfaceOperationType.vaultV2Deposit} dataTestId="deposit-tab" />
        <OperationModeButton onClick={() => {
        setType(InterfaceOperation.InterfaceOperationType.vaultV2Withdraw);
      }} label="Withdraw" isActive={type === InterfaceOperation.InterfaceOperationType.vaultV2Withdraw} dataTestId="withdraw-tab" disabled={!hasHolding} />
      </div>
      {type === InterfaceOperation.InterfaceOperationType.vaultV2Deposit && <VaultV2OperationDeposit vaultAddress={vaultAddress} vaultData={vaultData} />}
      {type === InterfaceOperation.InterfaceOperationType.vaultV2Withdraw && <VaultV2OperationWithdraw vaultAddress={vaultAddress} vaultData={vaultData} />}
    </div>;
};
export default VaultV2SimpleActionPanel;